import snappbot from '../img/snappbot.png';

/**
 * Decorative Snappbot mascot. Hidden below 1200px width via CSS.
 * Marked role="presentation" so screen readers skip it.
 */
export function renderRobot() {
    return `
        <div class="col-md-2 col-lg-2">
            <img class="robot" src="${snappbot}" alt="" role="presentation"/>
        </div>
    `;
}
